import React from "react";
import s from "./Tooltip.less";

interface TooltipIProps {
  text?: string;
  children: React.ReactNode;
  variant?: "top" | "bottom";
  customClassName?: any;
  hoverable?: boolean;
}

const Tooltip = ({
  text,
  children,
  variant,
  customClassName = " ",
  hoverable = false,
}: TooltipIProps) => {
  return (
    <div
      className={[s["tooltip-container"], hoverable ? s["hoverable"] : ""].join(
        " "
      )}
    >
      {children}
      {text && (
        <div
          className={[
            variant ? s[`tooltip-${variant}`] : s["tooltip-top"],
            customClassName,
          ].join(" ")}
        >
          {text}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
